export const ORDER_LOGIN_TYPE = 'orderLoginType';
export const GOOGLE = 'Google';
export const FACEBOOK = 'Facebook';
export const MANUAL = 'Manual';
export const SUCCESS = 'SUCCESS';
export const CONNECTED = 'connected';
